import Vue from "vue";
import Vuex from "vuex";

import home from "@/modules/home/vuex/index";
import document from "@/modules/document/vuex/index";
import trn from "@/modules/trn/vuex/index";
import theme from "@/modules/theme/vuex/index";
import company from "@/modules/company/vuex/index";
import selfie from "@/modules/selfie/vuex/index";
import nationalId from "@/modules/national/vuex/index";

import { RootState } from "./types";
import HomeState from "@/modules/home/vuex/state";
import DocumentState from "@/modules/document/vuex/state";
import TrnState from "@/modules/trn/vuex/state";
import ThemeState from "@/modules/theme/vuex/state";
import CompanyState from "@/modules/company/vuex/state";
import SelfieState from "@/modules/selfie/vuex/state";
import NationalIdState from "@/modules/national/vuex/state";

Vue.use(Vuex);

const initialState: RootState = {
  home: HomeState,
  trn: TrnState,
  document: DocumentState,
  theme: ThemeState,
  company: CompanyState,
  selfie: SelfieState,
  nationalId: NationalIdState,
};

export default new Vuex.Store({
  state: () => initialState,
  mutations: {},
  actions: {},
  modules: {
    document,
    home,
    trn,
    theme,
    company,
    selfie,
    nationalId,
  },
});
